
  import {
    reactive,
    defineComponent,
    getCurrentInstance,
    onMounted,
    onBeforeMount
  } from 'vue';
  import {
    useRouter
  } from 'vue-router';
  import common from '@/assets/ts/common';
  import {Toast} from 'vant';
  interface HomeConfig {
    scanWxCodeData: any[],
  }
  export default defineComponent({
    setup() {
      onMounted(() => {
        getBanner();
      });
      const router = useRouter();
      const data = reactive<HomeConfig>({
        scanWxCodeData:[],
      });
      const {
        ctx
      }: any = getCurrentInstance();
      const getBanner = (): void => {
        // 经销商  /adproduct/getBannerTopList
        // 客户    /adproduct/getBannerTopListCustom
        common.request("get", "/adproduct/getBannerTopList")
          .then((res: any) => {
            data.scanWxCodeData = res.data;
            console.log(data.scanWxCodeData)
          })
      };
      // const goRegister = () => {
      //   router.push('/register');
      // };
      // const goWxLogin = () => {
      //   location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxffd7309385d2fc24&redirect_uri=https://zcq.jnddsoft.cn&response_type=code&connect_redirect=1&scope=snsapi_userinfo&state=STATE#wechat_redirect';
      // };
      return {
        data,
        // goRegister,
        // goWxLogin
      };
    }
  });
